module.exports = __webpack_public_path__ + "img/au_logo_text.d8e072d4.png";